var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 19.8333,
    height: 20,
    viewBox: "0 0 19.8333 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8333 10.2273C19.8333 9.5182 19.769 8.8364 19.6494 8.1818H10.119V12.05H15.5649C15.3304 13.3 14.6175 14.3591 13.5458 15.0682V17.5773H16.816C18.7294 15.8364 19.8333 13.2727 19.8333 10.2273Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.119 20C12.8512 20 15.1417 19.1045 16.8159 17.5773L13.5457 15.0682C12.6396 15.6682 11.4805 16.0227 10.119 16.0227C7.48344 16.0227 5.2527 14.2636 4.45693 11.9H1.07626V14.4909C2.74135 17.7591 6.16341 20 10.119 20Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.45693 11.9C4.25455 11.3 4.1396 10.6591 4.1396 10C4.1396 9.3409 4.25455 8.7 4.45693 8.1V5.5091H1.07626C0.391 6.8591 0 8.3864 0 10C0 11.6136 0.391 13.1409 1.07626 14.4909L4.45693 11.9Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.119 3.9773C11.6046 3.9773 12.9385 4.4818 13.9873 5.4727L16.8896 2.6045C15.1372 0.9909 12.8465 0 10.119 0C6.16341 0 2.74135 2.2409 1.07626 5.5091L4.45693 8.1C5.2527 5.7364 7.48344 3.9773 10.119 3.9773Z",
    fill: "#E94235"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7bec4bea509227bebb2af62c16a50cf6.svg";
export { ForwardRef as ReactComponent };